import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import NewsEventManager from './AdminNewsEvents';
import ContactManager from './AdminContactMessages';
import TestimonialManager from './AdminTestimonials';
import AdminServices from './AdminServices';
import '../styles/admin.css';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin-login');
  };

  return (
    <div className="admin-shell">
      <div className="admin-shell-sidebar">
        <Sidebar />
      </div>
      <div className="admin-shell-main">
        <div className="admin-shell-header">
          <Header onLogout={handleLogout} />
        </div>
        <main className="admin-shell-content">
          <Routes>
            <Route path="/" element={<Navigate to="news-events" />} />
            <Route path="news-events" element={<NewsEventManager />} />
            <Route path="contacts" element={<ContactManager />} />
            <Route path="testimonials" element={<TestimonialManager />} />
            <Route path="services" element={<AdminServices />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
